import React from 'react';
import { Nav, Box, Paragraph } from '@landr/maestro';
import styled from 'styled-components';

export interface NavigationDropdownItemProps {
    onClick: (event: React.MouseEvent<Element, MouseEvent>) => void;
    icon: React.ElementType;
    title: string;
    subTitle: string;
    path: string;
    target?: React.HTMLAttributeAnchorTarget;
}

export const NavigationDropdownItem: React.FC<NavigationDropdownItemProps> = ({
    onClick,
    icon: Icon,
    title,
    subTitle,
    path,
    target,
}) => {
    return (
        <Nav.DropdownItem
            as="a"
            key={path}
            onClick={onClick}
            href={path}
            target={target}
        >
            <Box display="flex" alignItems="flex-start">
                <Box
                    mr="md"
                    backgroundColor="rgba(253, 146, 0, 0.32)"
                    p="xs"
                    sx={{ borderRadius: '8px' }}
                >
                    <Icon />
                </Box>
                <Box>
                    <Box display="flex" alignItems="center">
                        <Box>
                            <Paragraph m="0">{title}</Paragraph>
                        </Box>
                    </Box>
                    <Styled.TextWrapper>
                        <Paragraph contrast="low" m="0" size="sm">
                            {subTitle}
                        </Paragraph>
                    </Styled.TextWrapper>
                </Box>
            </Box>
        </Nav.DropdownItem>
    );
};

const Styled = {
    TextWrapper: styled.div`
        text-wrap: wrap;
    `,
};
